import { GameEngine } from "neo-games";

export class GameDefinition extends GameEngine.GameDefinitionBase {
    /**
     * @property ClientHostType - type name for client host, eg.(Default, Desktop ...)
     */
    public get Gamble(): boolean {
        return this.getValue("Gamble", true);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Common/GameDefinition.ts
 **/